<main>
    <div class="content">
        <div class="image-container">
            <img [src]="baseApiUrl + '/uploads/images/publications/published_report/published_report_1.jpg'" alt="" class="main-image">
            <p class="image-text">{{ 'report.Key Financial Performance' | translate }}</p>
        </div>
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarNav">
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <a class="nav-link" href="/publication/published-report">{{ 'report.Annual Report' | translate }}</a>
                    </li>      
                    <li class="nav-item active">
                        <a class="nav-link" href="/publication/key-financial">{{ 'report.Key Financial Performance' | translate }}</a>
                    </li>     
                    <li class="nav-item">
                        <a class="nav-link" href="/publication/key-operational">{{ 'report.Key Operational Performance' | translate }}</a>
                    </li>     
                    <li class="nav-item">
                        <a class="nav-link" href="/publication/csr">{{ 'report.CSR' | translate }}</a>
                    </li>             
                </ul>
            </div>
        </nav>
        <div class="key-financial">
           <h3>{{ 'report.Key Financial Performance' | translate }}</h3>
           <!-- <img src="images/publications/key_financial/key_financial_2.png" alt="">
           <img src="images/publications/key_financial/key_financial_3.png" alt="">
           <img src="images/publications/key_financial/key_financial_4.png" alt=""> -->
           <table class="table table-hover" style="background-color: white; margin-top: 50px;">
            <thead style="background-color: #005EB8; color: white;">
              <tr>
                <th scope="col">Performance Indicator</th>
                <th scope="col">2025</th>
                <th scope="col">2024</th>
                <th scope="col">2023</th>
                <th scope="col">2022</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Total income (USD)</td>
                <td>9,167,612</td>
                <td>11,260,707</td>
                <td>13,858,526</td>
                <td>12,450,464</td>
              </tr>
              <tr>
                <td>Total expense (USD)</td>
                <td>9,019,191</td>
                <td>9,940,202</td>
                <td>16,230,419</td>
                <td>9,414,183</td>
              </tr>
              <tr>
                <td>Net profit (USD)</td>
                <td>148,421</td>
                <td>1,320,506</td>
                <td>(2,371,893)</td>
                <td>3,036,281</td>
              </tr>
              <tr>
                <td>Total borrowing (USD)</td>
                <td>32,500,000</td>
                <td>37,000,000</td>
                <td>50,000,000</td>
                <td>60,087,588</td>
              </tr>
              <tr>
                <td>Total assets (USD)</td>
                <td>67,526,475</td>
                <td>72,311,958</td>
                <td>85,943,515</td>
                <td>96,859,121</td>
              </tr>
              <tr>
                <td>Total equity (USD)</td>
                <td>34,453,291</td>
                <td>34,375,712</td>
                <td>32,926,854</td>
                <td>35,298,748</td>
              </tr>
              <tr>
                <td>Paid-up capital (USD)</td>
                <td>25,000,000</td>
                <td>25,000.000</td>
                <td>25,000,000</td>
                <td>25,000,000</td>
              </tr>
              <tr>
                <td>Financial Self-Sufficiency (FSS)</td>
                <td>101.65%</td>
                <td>94.16%</td>
                <td>98.20%</td>
                <td>123.49%</td>
              </tr>
              <tr>
                <td>Return on Assets (ROA)</td>
                <td>0.22%</td>
                <td>1.69%</td>
                <td>(2.61%)</td>
                <td>3.72%</td>
              </tr>
              <tr>
                <td>Return On Equity (ROE)</td>
                <td>0.43%</td>
                <td>3.92%</td>
                <td>(6.95%)</td>
                <td>8.99%</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="bottom-content-poster">
            <img [src]="baseApiUrl + '/uploads/images/customer_service/customer_service_1.jpg'" alt="">
            <a href="/download-app"><img [src]="baseApiUrl + '/uploads/images/mobile_download/mobile_download_1.jpg'" loading="lazy"></a>
        </div>
    </div>
</main>
